import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ContentCenterer from '../../ContentCenterer';

const Container = styled.div<{ scrolled: boolean; amount: number }>`
  width: 100%;
  border-bottom: 1px solid #ecedf7;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  position: fixed;
  top: ${(props) => (props.scrolled ? '0px' : `${68 - props.amount}px`)};
  background: white;
  z-index: 1;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
`;

type Props = {
  children?: React.ReactNode;
};

export function MainMenu({ children }: Props) {
  const [isTop, setIsTop] = useState(false);
  const [scrollAmount, setScrollAmount] = useState(0);

  useEffect(() => {
    document.addEventListener('scroll', (e) => {
      let scrolled = document?.scrollingElement?.scrollTop;

      setScrollAmount(scrolled ?? 0);
      if (scrolled != null && scrolled >= 68) {
        setIsTop(true);
      } else {
        setIsTop(false);
      }
    });
  }, []);

  return (
    <Container scrolled={isTop} amount={scrollAmount}>
      <ContentCenterer flex={1}>
        <Content>{children}</Content>
      </ContentCenterer>
    </Container>
  );
}
